module.exports = __webpack_public_path__ + "img/hinata-nend.7f16ab3b.jpg";